import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from 'libphonenumber-js/mobile';
import * as Yup from 'yup';

export const DEFAULT_COUNTRY = 'AU';

export function isValidLoginIdentifier(value: any): boolean {
  if (/^[A-Za-z0-9_-]+$/.test(value)) {
    return true;
  }
  if (value.includes('@')) {
    return Yup.string().email().isValidSync(value);
  }
  return isValidPhoneNumber(value, DEFAULT_COUNTRY);
}

export function normalizeLoginIdentifier(value: string): string {
  if (value.includes('@')) {
    return value;
  }
  const phoneNumber = parsePhoneNumberFromString(value, DEFAULT_COUNTRY);
  return phoneNumber?.number ?? value;
}

export function displayEmail(email: string): string {
  const [local, domain] = email.split('@');
  return (
    local +
    '*'.repeat(5) +
    '@' +
    domain.charAt(0) +
    '*'.repeat(5) +
    domain.slice(1)
  );
}
